module.exports = __webpack_public_path__ + "img/iata.276dd098.png";